import {
  Row,
  Col,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
  ModalFooter,
  Modal,
} from "reactstrap";
import { SwipeableDrawer } from "@mui/material";
import DataTable from "components/Core/DataTable";
import NotificationAlert from "react-notification-alert";
import Notify from "../../lib/Utils/Alert";

import PurchaseOrder from "../../lib/Core/Backend/Controllers/PurchaseOrder";
import Purchaser from "../../lib/Core/Backend/Controllers/Purchaser";
import { useRef, useEffect, useState, useMemo } from "react";
import HistorySKUDetails from "./HistorySKUDetails.jsx";
import useCatalogs from "hooks/useCatalogs";
import Utils from "lib/Utils/Utils";

const ModalHistorySKU = (props) => {
  const { modalHistory, toggleModalHistory, token } = props;
  const {currencies} = useCatalogs()
  const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const dataTableRef = useRef(null);
  const alert = useRef(null);
  const startDateInput = useRef();
  const endDateInput = useRef();
  const [dataTableData, setDataTableData] = useState({
    purchaseOrderResponse: [],
  });
  const [orderDetail, setOrderDetail] = useState([]);
  const [inputSearch, setInputSearch] = useState("");
  const [skuName, setSkuName] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const toggleDrawer = () => setOpenDrawer(!openDrawer);

  const header = [
    { title: "Sales order Date", data: "createdAt", sortable: true },
    { title: "Sales order Number", data: "name", sortable: true },
    { title: "Purchaser", data: "purchaser", sortable: true },
    { title: "Gift Card Name", data: "purchaseOrderDetail[0].cardTypeName", sortable: true },
    { title: "Currency", data: "currency", sortable: true },
    { title: "Face Value", data: "purchaseOrderDetail[0].amount", sortable: true },
    { title: "Qty", data: "purchaseOrderDetail[0].quantity", sortable: true },
    { title: "Purchaser discount", data: "purchaseOrderDetail[0].discount", sortable: true },
    { title: "Purchaser fee", data: "purchaseOrderDetail[0].fee", sortable: true },
    { title: "Purchase order number", data: "name", sortable: true },
    { title: "Supplier", data: "supplierName", sortable: true },
    { title: "Face value", data: "subtotal", sortable: true },
    { title: "Qty", data: "itemQtyNo", sortable: true },
    { title: "Supplier discount", data: "supplierDiscount", sortable: true },
    { title: "Supplier fee", data: "supplierFee", sortable: true },
    {
      title: "Status sales order",
      data: "status",
      render: (data) => {
        if (data) {
          switch (data) {
            case 1:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-wisteria">open</span>`;
            case 2:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-nileBlue">in progress</span>`;
            case 3:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">canceled</span>`;
            case 4:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-shamrock">completed</span>`;
            case 5:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-warning">On hold</span>`;
            default:
              return "Error";
          }
        }
      },
    },
    {
      title: "Status purchase order",
      data: "status",
      render: (data) => {
        if (data) {
          switch (data) {
            case 1:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-wisteria">open</span>`;
            case 2:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-nileBlue">in progress</span>`;
            case 3:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">canceled</span>`;
            case 4:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-shamrock">completed</span>`;
            case 5:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-warning">On hold</span>`;
            default:
              return "Error";
          }
        }
      },
    },
  ];
  const prepareDetails = (row) => {
    setOrderDetail(row.data());
    toggleDrawer();
  };

  const getHistoryBySKU = () => {
    if (inputSearch.length > 0 && startDate && endDate) {
      const _startDate = new Date(startDate).getTime().toString().substring(0,10)
      const _endDate = new Date(endDate).getTime().toString().substring(0,10)
      purchaserCtl.all(purchaserData => {
        purchaseOrderCtl.getAllHistoryBySKU(inputSearch, _startDate, _endDate, (data) => {
        if (data && !data.error) {
          data.forEach(item => {
            let hasPurchaserDetail = false
            let supplierDetail = []
            let purchaser = item.purchaseSourceTypeId === 2 ? purchaserData.find(purchaser => purchaser.id === item.purchaseSourceId) : null;
            let itemCurrency = currencies.find(currency => currency.id === item.currencyId)
            const currencyFormat = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: itemCurrency?.code ?? 'USD'
            })
            if (item.purchaseOrderDetail.length > 0) {
              item.purchaseOrderDetail.forEach(orderDetail => {
                if (orderDetail.detailProcessing.length > 0){
                  supplierDetail = orderDetail.detailProcessing[0]
                  hasPurchaserDetail = true
                }
              })
            }

            item.purchaseOrderDetail[0].amount = currencyFormat.format(item.purchaseOrderDetail[0].amount)
            item.purchaseOrderDetail[0].discount = Utils.percentFormat(item.purchaseOrderDetail[0].discount/100)
            item.purchaseOrderDetail[0].fee = currencyFormat.format(item.purchaseOrderDetail[0].fee)


            item.supplierName = hasPurchaserDetail > 0 ? supplierDetail.supplierName : ''
            item.supplierFee = hasPurchaserDetail > 0 ? currencyFormat.format(supplierDetail.supplierFee) : '$0.00'
            item.supplierDiscount = hasPurchaserDetail > 0 ? Utils.percentFormat(supplierDetail.supplierDiscount/100) : '0%'
            item.itemQtyNo = hasPurchaserDetail > 0 ? supplierDetail.itemQtyNo : 0
            item.subtotal = currencyFormat.format(item.subtotal)
            item.purchaser = purchaser ? purchaser.name : 'N.A.'
            
          })
          
          setDataTableData(data);
          setSkuName(inputSearch);
        } else if (data.errorMessage) {
          setInputSearch("");
          Notify(alert, "danger", data.errorMessage);
        } else {
          Notify(alert, "danger", data.error);
        }
      })
      })
      
    } else {
      Notify(alert, "danger", "Please enter SKU");
    }
  };
  const toggleClose = () => {
    toggleModalHistory(); 
    setSkuName(''); 
    setDataTableData({})
  }
  const handleDate = (e) => {
    if( e.target.id === 'startDate'){
      setstartDate(e.target.value)
      setendDate(null)
      endDateInput.current.value = '';
      endDateInput.current.select();
    } else {
      if(!startDate){
        Notify(alert, 'danger', 'First Select a start date');
        endDateInput.current.value = '';
        startDateInput.current.focus();
        return;
      }
      setendDate(e.target.value)
    }
  }
  useEffect(() => {
    dataTableRef.current &&
      dataTableRef.current.dataTable
        .clear()
        .rows.add(dataTableData)
        .draw();
  }, [dataTableData]);
  return (
    <>
      <NotificationAlert ref={alert} />
      <Modal isOpen={modalHistory} toggle={toggleClose} size="xl">
        <ModalHeader toggle={toggleClose} className="bg-info">
          History by SKU: <b>{skuName}</b>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label for="mainPhone">SKU:</Label>
                <Input
                  type="text"
                  style={{ maxWidth: 400, height: 38 }}
                  value={inputSearch}
                  onChange={(e) => setInputSearch(e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for='startDate' >Start date</Label>
                <Input type='date' id='startDate' pattern='\d{4}-\d{2}-\d{2}' innerRef={startDateInput} onChange={handleDate}/>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for='endDate'>End date</Label>
                <Input type='date' id='endDate' pattern='\d{4}-\d{2}-\d{2}' innerRef={endDateInput} onChange={handleDate} min={startDate ? startDate : ''}/>
              </FormGroup>
            </Col>
            <Col className="col-3 text-center align-self-end">
              <Button
                initial={{ x: "-500%", opacity: 0 }}
                animate={{
                  x: 0,
                  opacity: 1,
                  transition: { delay: 0.4, duration: 0.5 },
                }}
                color="primary"
                onClick={getHistoryBySKU}
              >
                <i className="fas fa-search" /> Search
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <h4 >{dataTableData.stock ? `Stock: ${dataTableData.stock}` : `Stock: ${0}`}</h4>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <DataTable
                ref={dataTableRef}
                data={null}
                columns={header}
                responsive= {true}
                options={{ dom: "tip", order: [[0, 'desc']] }}
                addCustomButtons={[
                  {
                    callback: prepareDetails,
                    name: "purchaserDetails",
                    icon: "fas fa-info-circle",
                    style:
                      "padding: 5px 10px; background: transparent; font-size: 1.2rem",
                    props:
                      'data-toggle="tooltip" data-placement="top" title="See more details"',
                  },
                ]}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="flex-nowrap">
          <Col md={6} className="justify-content-end text-right">
            <Button
              type="submit"
              className="mr-3"
              color="secondary"
              onClick={toggleClose}
            >
              Close
            </Button>
          </Col>
        </ModalFooter>
      </Modal>
      <SwipeableDrawer
        anchor="right"
        open={openDrawer}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
      >
        <div style={{ width: "70vw" }}>
          <HistorySKUDetails data={orderDetail} />
        </div>
      </SwipeableDrawer>
    </>
  );
};

export default ModalHistorySKU;
